export default {
  filters: {
    recommend: 'Popular',
    favorites: 'Favorites',
    recents: 'Recent',
  },
  placeholder: {
    pending: 'Coming soon',
  },
  empty: {
    games: 'No games yet',
    gamesHint: 'Try another category',
    favorites: 'No favorites yet',
    favoritesHint: 'Tap the star on a game card to save it',
    recents: 'No recent games',
    recentsHint: 'Games you play will show up here',
  },
  loadMore: {
    armed: 'Keep swiping up to load more…',
    loading: 'Loading…',
    end: '- No more -',
  },
  search: {
    searchGames: 'Search',
    placeholder: 'Search games/providers',
    trending: 'Trending searches',
    result: 'Found {count} results',
    searching: 'Searching…',
    empty: 'No games found',
    emptyHint: 'Try a different keyword',
    clear: 'Clear',
    vendor: 'Provider',
  },
  jackpotTicker: {
    title: 'Live Wins',
    live: 'LIVE',
    subtitle: 'Congrats to these big winners',
    empty: 'No wins yet. Be the next big winner!',
  },
  play: {
    loading: 'Loading game...',
    transferTitle: 'Credit transfer successful',
    copyTitle: 'Copied successfully',
    balanceLabel: 'Current「{venue}」balance',
    /** USDT site + CNY-mapped venue: rate note under amount */
    mappedRatePrefix: 'In-venue pricing',
    mappedRateEq: '1 ¥ = 1 {code}',
    mappedRateSuffix: ', reversible in/out at equal value',
    transferDesc:
      'To top up, return to the BetCorgi home page, or tap the floating button in the top-right to recharge directly',
    copyDesc:
      'Top up here, return to the BetCorgi home page, or tap the floating button in the top-right to recharge directly',
    start: 'Start game',
    menu: {
      exit: 'Exit',
      deposit: 'Deposit',
      transfer: 'Transfer',
      support: 'Support',
      expand: 'Open menu',
      collapse: 'Close menu',
    },
  },
}
